<template>
  <div class="distribution-rights" v-loading="loading">
    <!-- 未购买分销商等级视图 -->
    <div v-if="!isDistributor" class="not-purchased">
      <div class="section-header">
        <div class="section-title">查看分销权益</div>
        <el-button @click="backToCourses">返回我的课程</el-button>
      </div>
      <div class="benefit-bar">
        <div class="benefit-item" v-for="b in benefits" :key="b.title" :style="b.style">
          <img :src="b.icon" class="benefit-icon">
          <div class="benefit-text">
            <div class="benefit-title">{{ b.title }}</div>
            <div class="benefit-sub">{{ b.sub }}</div>
          </div>
        </div>
      </div>
      <div class="level-section">
        <div class="section-subtitle">分销等级</div>
        <div class="levels">
          <div class="level-card" v-for="lv in levels" :key="lv.id" :class="{ selected: selectedLevel === lv.id }" @click="selectLevel(lv.id)">
            <div class="level-top" :class="{ selected: selectedLevel === lv.id }">
              <img :src="lv.icon" class="level-icon">
              <div class="level-title">{{ lv.title }}</div>
            </div>
            <div class="level-desc"><span class="desc-label">分销权益：</span>{{ lv.desc }}</div>
            <i v-if="selectedLevel === lv.id" class="el-icon-check level-check"></i>
          </div>
        </div>
      </div>
      <div class="pay-section">
        <div class="section-subtitle">支付方式</div>
        <div class="pay-options">
          <div class="pay-card" :class="{ selected: payMethod === 'wechat' }" @click="selectPay('wechat')">
            <img src="@/assets/image/weixin.png" class="pay-icon">
            <div class="pay-title">微信支付</div>
          </div>
          <div class="pay-card" :class="{ selected: payMethod === 'alipay' }" @click="selectPay('alipay')">
            <img src="@/assets/image/zhifubao.png" class="pay-icon">
            <div class="pay-title">支付宝支付</div>
          </div>
        </div>
      </div>
      <div class="action-bar">
        <el-button type="primary" class="pay-btn" @click="goPay">去支付</el-button>
      </div>
    </div>

    <!-- 已购买分销商等级视图 -->
    <div v-else class="purchased">
      <div class="level-header">
        <div class="level-title">{{ currentLevelName || '分销商' }}</div>
      </div>

      <div class="dashboard-stats">
        <div class="stat-card">
          <div class="stat-icon order-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="stat-info">
            <div class="stat-label">分销订单</div>
            <div class="stat-value">共{{ earningsStats.totalOrders }}条</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon coin-icon">
            <img :src="require('@/assets/image/logo_mygold.png')"/>
          </div>
          <div class="stat-info">
            <div class="stat-label">我的金币</div>
            <div class="stat-value">
              <span class="total">{{ earningsStats.totalEarnings }}</span>
              <span class="withdrawable">可提现{{ earningsStats.availableBalance }}</span>
            </div>
          </div>
        </div>
        <div class="withdraw-action">
          <el-button type="primary" class="withdraw-btn" @click="goWithdraw">提现</el-button>
        </div>
      </div>

      <!-- 收益明细 -->
      <div class="income-details-section" v-loading="earningsLoading">
        <div class="section-title">收益明细</div>
        <div class="details-list">
          <div class="detail-item" v-for="item in earningsList" :key="item.id">
            <div class="item-main">
              <div class="course-name">{{ item.courseName }}</div>
              <div class="item-meta-row">
                <div class="meta-col">
                  <div class="label">订单号：</div>
                  <div class="val">{{ item.orderNo }}</div>
                </div>
                <div class="meta-col">
                  <div class="label">下单人：</div>
                  <div class="val">{{ item.buyerName }} {{ item.buyerPhone }}</div>
                </div>
                <div class="meta-col">
                  <div class="label">下单时间：</div>
                  <div class="val">{{ item.orderTime }}</div>
                </div>
                <div class="meta-col">
                  <div class="label">订单金额：</div>
                  <div class="val">{{ item.orderAmount }}元</div>
                </div>
              </div>
            </div>
            <div class="item-income">
              +{{ item.earningsCoin }}金币
            </div>
          </div>
          <el-empty v-if="!earningsLoading && earningsList.length === 0" description="暂无收益记录" />
        </div>
        
        <!-- 分页 -->
        <div class="pagination-container" v-if="earningsTotal > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :total="earningsTotal"
            :current-page.sync="earningsQuery.pageNum"
            :page-size="earningsQuery.pageSize"
            @current-change="fetchEarningsDetails">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDistributorBenefit, buyDistributor, getEarningsDetails, getEarningsStatistics } from '@/api/authApi'

export default {
  name: 'DistributionRights',
  props: {
    hasPurchased: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      isDistributor: false,
      currentLevel: null,
      currentLevelName: '',
      expireTime: '',
      selectedLevel: 1,
      payMethod: 'wechat',
      benefits: [
        { title: '更多权益', sub: '更多权益增加中...', icon: require('@/assets/image/security.png'), style: { background: 'linear-gradient(90deg, #FFE8C2 0%, #FFD39A 100%)' } },
        { title: '分销优惠价', sub: '购买享受优惠价', icon: require('@/assets/image/percent_sign.png'), style: { background: 'linear-gradient(90deg, #FFD1D6 0%, #FF9BB3 100%)' } },
        { title: '高返佣', sub: '佣金赚不停', icon: require('@/assets/image/money_placholder.png'), style: { background: 'linear-gradient(90deg, #DDEBFF 0%, #B7D5FF 100%)' } }
      ],
      levels: [
        // 默认数据，会被接口数据覆盖
        { id: 1, title: '一级分销商', desc: '可享课程题库购买9成折扣', icon: require('@/assets/image/logo_vip_dialog.png') },
        { id: 2, title: '二级分销商', desc: '可享课程题库购买7成折扣', icon: require('@/assets/image/logo_gold_dialog.png') },
        { id: 3, title: '三级分销商', desc: '可享课程题库购买5成折扣', icon: require('@/assets/image/logo_sliver_vip_dialog.png') }
      ],
      // 收益明细相关数据
      earningsLoading: false,
      earningsList: [],
      earningsTotal: 0,
      earningsQuery: {
        pageNum: 1,
        pageSize: 10
      },
      earningsStats: {
        totalOrders: 0,
        totalEarnings: 0,
        availableBalance: 0
      }
    }
  },
  mounted() {
    this.fetchDistributorInfo()
  },
  watch: {
    hasPurchased(val) {
      this.isDistributor = !!val
      if (val) {
        this.fetchEarningsDetails()
        this.fetchEarningsStatistics()
      }
    }
  },
  methods: {
    async fetchEarningsStatistics() {
      if (!this.isDistributor) return
      try {
        const res = await getEarningsStatistics()
        const data = res.data || {}
        this.earningsStats = {
          totalOrders: data.totalOrders || 0,
          totalEarnings: data.totalEarnings || 0,
          availableBalance: data.availableBalance || 0
        }
      } catch (err) {
        console.error('Failed to fetch earnings statistics', err)
      }
    },
    async fetchEarningsDetails() {
      if (!this.isDistributor) return
      this.earningsLoading = true
      try {
        const res = await getEarningsDetails(this.earningsQuery)
        const data = res.data || {}
        this.earningsList = data.list || []
        this.earningsTotal = Number(data.total) || 0
      } catch (err) {
        this.$message.error((err && err.message) || '获取收益明细失败')
        this.earningsList = []
        this.earningsTotal = 0
      } finally {
        this.earningsLoading = false
      }
    },
    async fetchDistributorInfo() {
      this.loading = true
      try {
        const res = await getDistributorBenefit()
        const data = res && res.data
        if (data) {
          this.currentLevel = data.currentLevel
          this.currentLevelName = data.currentLevelName
          this.expireTime = data.expireTime
          
          // Determine if user is a distributor
          // currentLevel: null -> not distributor, 0 -> cancelled, 1-3 -> level
          this.isDistributor = (this.currentLevel && this.currentLevel > 0)

          if (this.isDistributor) {
            this.fetchEarningsDetails()
            this.fetchEarningsStatistics()
          }

          if (Array.isArray(data.levelBenefits)) {
            const levelIcons = {
              1: require('@/assets/image/logo_vip_dialog.png'),
              2: require('@/assets/image/logo_gold_dialog.png'),
              3: require('@/assets/image/logo_sliver_vip_dialog.png')
            }
            
            this.levels = data.levelBenefits.map(item => {
              const level = item.level
              const icon = levelIcons[level] || require('@/assets/image/logo_vip_dialog.png')
              return {
                id: level,
                title: item.levelName || `等级${level}`,
                desc: item.benefitDescription || `享受课程${item.courseDiscountRate}%优惠`,
                icon: icon,
                raw: item
              }
            })
            
            // If levels exist, select the first one by default if none selected
            if (this.levels.length > 0 && !this.levels.find(l => l.id === this.selectedLevel)) {
              this.selectedLevel = this.levels[0].id
            }
          }
        }
      } catch (err) {
        this.$message.error((err && err.message) || '获取权益信息失败')
      } finally {
        this.loading = false
      }
    },
    backToCourses() {
      this.$emit('back-to-courses')
    },
    goWithdraw() {
      this.$router.push('/member-center/withdraw')
    },
    selectLevel(id) {
      this.selectedLevel = id
    },
    selectPay(id) {
      this.payMethod = id
    },
    async goPay() {
      if (!this.selectedLevel) {
        this.$message.warning('请选择分销等级')
        return
      }

      const selectedLevelObj = this.levels.find(l => l.id === this.selectedLevel)
      if (!selectedLevelObj) {
        this.$message.error('选中的等级无效')
        return
      }

      const payTypeMap = {
        'wechat': 1,
        'alipay': 2
      }
      
      // 尝试获取价格，如果raw中有price则使用，否则默认为0
      const price = selectedLevelObj.raw && selectedLevelObj.raw.price != null ? Number(selectedLevelObj.raw.price) : 0

      const params = {
        cashAmount: price,
        coinAmount: 0,
        couponAmount: 0,
        couponId: 0,
        distributorLevel: this.selectedLevel,
        payType: payTypeMap[this.payMethod] || 1
      }

      this.loading = true
      try {
        const res = await buyDistributor(params)
        const data = res.data
        
        let orderNo = null
        if (data && typeof data === 'object') {
          orderNo = data.orderNo || data.order_no || data.outTradeNo || data.out_trade_no || data.orderId || data.id
        } else if (typeof data === 'string') {
          orderNo = data
        }

        if (orderNo) {
          this.$router.push({
            name: 'payment',
            params: { id: String(orderNo) },
            query: {
              orderNo: String(orderNo),
              bizType: 'distributor',
              payType: params.payType,
              title: selectedLevelObj.title || '分销商权益',
              price: price,
              totalAmount: price
            }
          })
        } else {
          this.$message.error('创建订单失败，未获取到订单号')
        }
      } catch (err) {
        console.error(err)
        this.$message.error(err.message || '创建订单失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.distribution-rights {
  padding: 20px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;

    .section-title {
      font-size: 20px;
      font-weight: bold;
    }
  }

  // 未购买视图样式
  .not-purchased {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 16px;

    .benefit-bar { 
      background: #fff; 
      border: 0; 
      border-radius: 8px; 
      padding: 4px 0 0; 
      margin-bottom: 20px; 
      display: flex; 
      gap: 12px; 
      flex-wrap: wrap; 
    }

    .benefit-item {
      display: flex;
      align-items: center;
      gap: 12px;
      border-radius: 12px;
      padding: 10px 16px;
      min-width: 200px;
      height: 48px;
      position: relative;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0,0,0,.06);
    }

    .benefit-item::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, rgba(255,255,255,.35) 0%, rgba(255,255,255,0) 60%);
      pointer-events: none;
    }

    .benefit-icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(0,0,0,.08);
    }

    .benefit-text {
      display: flex;
      flex-direction: column;
      line-height: 1.2;
    }

    .benefit-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }

    .benefit-sub {
      font-size: 12px;
      color: #606266;
    }

    .section-subtitle {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 12px 0;
    }

    .level-section { 
      padding-top: 12px; 
      border-top: 1px solid #eee; 
    }

    .levels { 
      display: grid; 
      grid-template-columns: repeat(3, 1fr); 
      gap: 16px; 
    }

    .level-card { 
      background: #fff; 
      border: 1px solid #eaeaf2; 
      border-radius: 12px; 
      overflow: hidden; 
      position: relative; 
      cursor: pointer; 
    }

    .level-top { 
      height: 90px; 
      display: flex; 
      align-items: center; 
      gap: 10px; 
      padding: 16px; 
      background: linear-gradient(135deg, #f0f0f3 0%, #f7f7f9 100%); 
      position: relative; 
    }

    .level-card.selected { 
      border-color: var(--theme-primary); 
      box-shadow: 0 0 0 2px rgba(62,44,205,.18); 
    }

    .level-card.selected .level-top { 
      background: linear-gradient(135deg, rgba(62,44,205,.22) 0%, rgba(62,44,205,.12) 100%); 
    }

    .level-icon { 
      width: 44px; 
      height: 44px; 
      object-fit: contain; 
    }

    .level-title { 
      font-size: 14px; 
      font-weight: 600; 
    }

    .level-desc { 
      padding: 12px 14px; 
      font-size: 13px; 
      color: #606266; 
      background: #f7f7f9; 
      border-radius: 10px; 
      margin: 12px; 
    }

    .desc-label { 
      color: #909399; 
      margin-right: 4px; 
    }

    .level-top::after { 
      content: 'V'; 
      position: absolute; 
      right: 12px; 
      top: 2px; 
      font-size: 72px; 
      color: rgba(255,255,255,.8); 
      opacity: .25; 
      pointer-events: none; 
    }

    .level-card.selected::after { 
      content: ''; 
      position: absolute; 
      right: 0; 
      bottom: 0; 
      width: 38px; 
      height: 38px; 
      background: var(--theme-primary); 
      clip-path: polygon(100% 0, 100% 100%, 0 100%); 
      border-bottom-right-radius: 10px; 
    }

    .level-check { 
      position: absolute; 
      right: 8px; 
      bottom: 6px; 
      color: #fff; 
      z-index: 2; 
    }

    .pay-section { 
      margin-top: 20px; 
      padding-top: 16px; 
      border-top: 1px solid #eee; 
    }

    .pay-options { 
      display: grid; 
      grid-template-columns: repeat(2, 1fr); 
      gap: 16px; 
    }

    .pay-card { 
      background: #fff; 
      border: 1px solid #eaeaf2; 
      border-radius: 8px; 
      padding: 14px 16px; 
      display: flex; 
      align-items: center; 
      gap: 12px; 
      cursor: pointer; 
    }

    .pay-card.selected { 
      border-color: var(--theme-primary); 
      background: #fff; 
      box-shadow: 0 0 0 2px rgba(62,44,205,.12); 
    }

    .pay-icon { 
      width: 34px; 
      height: 34px; 
      border-radius: 50%; 
    }

    .pay-title { 
      font-size: 14px; 
      font-weight: 500; 
      color: #303133; 
    }

    .action-bar { 
      margin-top: 24px; 
    }

    .pay-btn { 
      width: 100%; 
      height: 44px; 
      background: var(--theme-primary); 
      border-color: var(--theme-primary); 
      border-radius: 8px; 
      box-shadow: 0 2px 8px rgba(62,44,205,.35); 
    }
  }

  // 已购买视图样式
  .purchased {
    .level-header {
      margin-bottom: 24px;
      .level-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
    }

    .dashboard-stats {
      background: #fff;
      border: 1px solid #eaeaf2;
      border-radius: 8px;
      padding: 24px 30px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      
      .stat-card {
        display: flex;
        align-items: center;
        margin-right: 80px;
        
        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          font-size: 24px;
          
          &.order-icon {
            background-color: #e6f0ff;
            color: #3579f7;
          }
          
          &.coin-icon {
            background-color: #fff7e6;
            color: #ff9900;
          }
        }
        
        .stat-info {
          display: flex;
          flex-direction: column;
          
          .stat-label {
            font-size: 14px;
            color: #333;
            font-weight: 500;
            margin-bottom: 4px;
          }
          
          .stat-value {
            font-size: 14px;
            color: #666;
            
            .total {
              font-weight: bold;
              color: #333;
              margin-right: 8px;
            }
          }
        }
      }
      
      .withdraw-action {
        margin-left: auto;
        
        .withdraw-btn {
          background-color: #4034eb;
          border-color: #4034eb;
          color: #fff;
          padding: 10px 30px;
          border-radius: 4px;
          
          &:hover {
            background-color: #554af0;
            border-color: #554af0;
          }
        }
      }
    }

    .income-details-section {
      background: #fff;
      padding: 0;
      
      .section-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }
      
      .details-list {
        .detail-item {
          padding: 24px 0;
          border-bottom: 1px dashed #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          &:last-child {
            border-bottom: none;
          }
          
          .item-main {
            flex: 1;
            
            .course-name {
              font-size: 15px;
              color: #333;
              font-weight: 500;
              margin-bottom: 16px;
            }
            
            .item-meta-row {
              display: flex;
              gap: 60px;
              
              .meta-col {
                font-size: 13px;
                display: flex;
                flex-direction: column;
                gap: 8px;
                
                .label {
                  color: #909399;
                }
                
                .val {
                  color: #303133;
                  font-weight: 500;
                }
              }
            }
          }
          
          .item-income {
            font-size: 16px;
            color: #4034eb;
            font-weight: bold;
            margin-left: 20px;
          }
        }
      }
      
      .pagination-container {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        
        ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #4034eb;
        }
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    padding: 10px;

    .purchased {
      .my-coins {
        flex-direction: column;
        gap: 10px;
        text-align: center;
      }
    }
  }
}
</style>
